<template>
    <div class="w-full flex flex-col items-start relative">
        <div class="w-full mt-1 flex flex-row items-center relative">
            <div :class="config.description && !hideLateralDescriptionValue ? 'flex-1 mr-4' : 'grow'" class="relative">
                <label :class="['block', 'text-sm', 'font-medium', 'text-gray-700', overrideLabelOpacity ? 'override-opacity' : '']">
                    {{ config.display_name }}
                </label>
                <div class="mt-2 w-full">
                    <json-forms :data="childData" :schema="childSchema" :uischema="childUiSchema" :renderers="renderers" @change="onJsonChange" />
                </div>
                <div v-if="errors.length" class="text-red-700 mt-1 text-xs">
                    <template v-for="error in errors" :key="error.$uid">
                        <span> * {{ error.$message }} </span>
                    </template>
                </div>
            </div>
            <div
                v-if="
                    hideLateralDescriptionValue &&
                    config.description &&
                    config.display_name?.trim()?.toLowerCase() !== config.description?.trim()?.toLowerCase()
                "
                class="relative flex flex-col items-center group ml-2">
                <Tooltip :tooltip-text="config.description" position="left" />
            </div>
            <div
                v-if="
                    config.description &&
                    !hideLateralDescriptionValue &&
                    config.display_name?.trim()?.toLowerCase() !== config.description?.trim()?.toLowerCase()
                "
                class="flex-1 p-3 bg-green-50 border-l-4 border-green-200 text-xs text-black rounded-md relative arrow-left"
                :class="errors.length ? 'mb-5' : ''">
                <span v-html="config.description"></span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, onUpdated, onUnmounted } from 'vue';
import { JsonForms } from '@jsonforms/vue';
import { vanillaRenderers } from '@jsonforms/vue-vanilla';
import Tooltip from './Tooltip.vue';

const props = defineProps({
    config: { type: Object, required: true },
    value: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: true },
    overrideLabelOpacity: { type: Boolean, default: false },
    hideLateralDescription: { type: Boolean, default: false },
    errors: { type: Array, default: () => [] }
});
const emit = defineEmits(['input']);

const childData = ref(props.value || {});
const renderers = Object.freeze([...vanillaRenderers]);

const childSchema = computed(() => {
    const val = props.config.value || {};
    if (val.jsonSchema) return val.jsonSchema;
    if (val.mappings) return val.mappings;
    return { type: 'object', properties: {} };
});

const childUiSchema = computed(() => ({
    type: 'VerticalLayout',
    elements: Object.keys(childSchema.value.properties || {}).map((key) => ({ type: 'Control', scope: `#/properties/${key}` }))
}));

function onJsonChange({ data }) {
    childData.value = data;
}

const hideLateralDescriptionValue = ref(props.hideLateralDescription);
function updateDescriptionVisibility() {
    hideLateralDescriptionValue.value = props.hideLateralDescription || window.innerWidth <= 1024;
}

onMounted(() => {
    updateDescriptionVisibility();
    window.addEventListener('resize', updateDescriptionVisibility);
});
onUpdated(updateDescriptionVisibility);
onUnmounted(() => window.removeEventListener('resize', updateDescriptionVisibility));

watch(
    childData,
    (newVal) => {
        emit('input', newVal);
    },
    { deep: true }
);
</script>
